import theme from '~/theme.js';
import React from 'react';
import LabelBadge, { getStatusVariant } from './LabelBadge';
import { formatVariation, isVariationWithinLimit, statusName } from './utils';

export const renderDataInfo = chips => {
    if (chips.length === 0) {
        return null;
    }
    return (
        <div>
            {chips.map(chip => <LabelBadge key={chip.label} label={chip.label} style={{ marginBottom: 2, marginRight: 3 }} variant={chip.variant}/>)}
        </div>
    );
};

export const renderStatusBadge = status => {
    if (!status || status === 'no_status') {
        return '';
    }
    return <LabelBadge label={statusName(status)} variant={getStatusVariant(status)}/>;
};

const truncatedTwoLineStyle = {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
};

// One voice speaks for itself; only two of them need saying who is who.
export const renderComments = (technician, final) => {
    if (!technician && !final) {
        return '';
    }
    if (!technician || !final) {
        const comment = technician || final;
        return <div style={truncatedTwoLineStyle} title={comment}>{comment}</div>;
    }

    return (
        <div style={truncatedTwoLineStyle} title={`Technician: ${technician} | Final: ${final}`}>
            <strong>Technician:</strong> {technician} | <strong>Final:</strong> {final}
        </div>
    );
};

// A saved photo is an object with a url; a fresh capture is a data-URL string.
export const imageSrc = image => (typeof image === 'string' ? image : image?.url);

export const openMeterPhoto = (image, number = null) => {
    const w = window.open('', '_blank');
    w.document.write(`<html><head><title>Meter Photo${number ? ` ${number}` : ''}</title></head><body style="margin:0;display:flex;justify-content:center;align-items:center;min-height:100vh;background:#222"><img src="${imageSrc(image)}" style="max-width:100%;max-height:100vh" /></body></html>`);
    w.document.close();
};

export const renderOkStatus = isOK => (
    <strong style={{ color: isOK ? theme.palette.labelBadge.success.color : theme.palette.labelBadge.danger.color }}>
        {isOK ? 'OK' : 'NOT OK'}
    </strong>
);

// The dash is "never will have" (first delta reading); the empty % marker is "not typed yet".
export const renderVariation = (value, incomparable = false) => {
    if (incomparable) {
        return <div style={{ padding: '4px 6px', borderRadius: 4 }}>-</div>;
    }
    const isOk = isVariationWithinLimit(value);
    const backgroundColor = isOk ? theme.palette.labelBadge.success.background : theme.palette.labelBadge.danger.background;
    return <div style={{ backgroundColor, padding: '4px 6px', borderRadius: 4 }}>{formatVariation(value)}</div>;
};

export const renderChecks = (count, needed) => (
    <strong style={{ color: count >= needed ? theme.palette.labelBadge.success.color : theme.palette.labelBadge.danger.color }}>
        {count}
    </strong>
);

export const renderYesNo = value => (
    <strong style={{ color: value ? theme.palette.labelBadge.success.color : theme.palette.labelBadge.danger.color }}>
        {value ? 'Yes' : 'No'}
    </strong>
);
